import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/inferences/list';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process({ payload }) {
  try {
    const { page = 1, limit = 20, deployment_id, inference_type } = payload || {};
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (deployment_id)   params.append('deployment_id', deployment_id);
    if (inference_type)  params.append('inference_type', inference_type);

    const response = yield call(
      axios.get,
      `${config.API_URL}/inference?${params}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
